import SelectMenu from "./SelectMenu";
import {
  FIELD_BASE,
  FIELD_DISABLED,
  FIELD_ERROR,
  FIELD_LABEL,
  fieldState,
} from "./formFieldStyles";

const FormSelect = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  options = [],
  error,
  required = false,
  disabled = false,
  placeholder,
  ...props
}) => (
  <div>
    {label && (
      <label htmlFor={name} className={FIELD_LABEL}>
        {label} {required && <span className="text-danger-500">*</span>}
      </label>
    )}

    {/* Optional fields keep the placeholder row so a choice can be cleared. */}
    <SelectMenu
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      options={options}
      placeholder={placeholder ?? `Select ${label || "an option"}`}
      disabled={disabled}
      clearable={!required}
      className={`${FIELD_BASE} pr-9 ${fieldState(error)} ${
        disabled ? FIELD_DISABLED : "text-gray-900"
      }`}
      {...props}
    />

    {error && <p className={FIELD_ERROR}>{error}</p>}
  </div>
);

export default FormSelect;
